var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("HeaderLandingNew"),
      _vm._v(" "),
      _c("div", { staticClass: "section-one section-premium" }, [
        _c("div", { staticClass: "so-content" }, [
          _c("h1", [_vm._v("Go Premium for as low as $1!")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        Enjoy listening to songs in full, listen to songs offline, and share\n        to missions. Cancel anytime!\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "so-content-action on-home" }, [
            _c(
              "a",
              {
                staticClass: "btn-n primary",
                attrs: { href: _vm.url, "aria-label": "Get MusicVerse" }
              },
              [_vm._v("Get MusicVerse")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn-n outline",
                attrs: { href: _vm.url, "aria-label": "Learn More MusicVerse" }
              },
              [_vm._v("\n          Learn More MusicVerse\n        ")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-section", attrs: { id: "premium-section" } },
        [
          _c("div", { staticClass: "content-section-2" }, [
            _c("div", { staticClass: "section-premium-content" }, [
              _c("div", { staticClass: "section-premium-header" }, [
                _c("h1", { staticClass: "premium-title" }, [
                  _vm._v("Premium Perks")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "premium-subtitle" }, [
                  _vm._v("Payment partners")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "payment-partners d-flex justify-content-center"
                  },
                  [
                    _c("img", {
                      attrs: { src: require("@/assets/visa.png"), alt: "logo" }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/master.png"),
                        alt: "logo"
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/american-express.png"),
                        alt: "logo"
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/wechat.png"),
                        alt: "logo"
                      }
                    }),
                    _vm._v(" "),
                    _vm.canApplePay
                      ? _c("img", {
                          attrs: {
                            src: require("@/assets/apple-pay.png"),
                            alt: "logo"
                          }
                        })
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "spc-box-container" }, [
                _c("div", { staticClass: "spc-box-item" }, [
                  _c("div", { staticClass: "spc-box-title" }, [_vm._v("Free")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "spc-box-start-form" }, [
                    _vm._v("Starts from")
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "spc-box-divider" }),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "spc-box-action",
                      style: { display: _vm.isSmallScreen ? "block" : "flex" }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "btn-n outline-primary",
                          style: {
                            width: _vm.isSmallScreen ? "auto" : "100%",
                            marginRight: _vm.isSmallScreen ? "0px" : "10px",
                            marginBottom: _vm.isSmallScreen ? "10px" : "0px"
                          },
                          attrs: {
                            href: _vm.androidUrl,
                            "aria-label": "Start for Free Android"
                          }
                        },
                        [_vm._v("Start for Free With Android")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn-n outline-primary",
                          style: { width: _vm.isSmallScreen ? "auto" : "100%" },
                          attrs: {
                            href: _vm.iosUrl,
                            "aria-label": "Start for Free Apple"
                          }
                        },
                        [_vm._v("Start for Free With Apple")]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "spc-box-item" }, [
                  _c("div", { staticClass: "spc-box-title" }, [
                    _vm._v("Premium")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "spc-box-start-form" }, [
                    _vm._v("Starts from")
                  ]),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "spc-box-divider" }),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "spc-box-action" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn-n primary",
                        attrs: { href: "#", "aria-label": _vm.premiumCtaLabel },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.handlePremiumCta($event)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.premiumCtaLabel))]
                    )
                  ])
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("FooterLandingNew")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spc-box-price" }, [
      _c("span", { staticClass: "spc-box-amount" }, [_vm._v("$0")]),
      _vm._v(" "),
      _c("span", { staticClass: "spc-box-per-month" }, [_vm._v("/month")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "spc-box-plan-list" }, [
      _c("li", { staticClass: "spc-box-plan-item" }, [
        _c("img", {
          staticClass: "spc-box-plan-icon",
          attrs: { src: require("@/assets/times.svg"), alt: "icon" }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Ads interuption")])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "spc-box-plan-item" }, [
        _c("img", {
          staticClass: "spc-box-plan-icon",
          attrs: { src: require("@/assets/times.svg"), alt: "icon" }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Play on shuffle mode")])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "spc-box-plan-item" }, [
        _c("img", {
          staticClass: "spc-box-plan-icon",
          attrs: { src: require("@/assets/times.svg"), alt: "icon" }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Streaming only, can’t listen offline")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spc-box-price" }, [
      _c("span", { staticClass: "spc-box-amount" }, [_vm._v("$1")]),
      _vm._v(" "),
      _c("span", { staticClass: "spc-box-per-month" }, [_vm._v("/month")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "spc-box-plan-list" }, [
      _c("li", { staticClass: "spc-box-plan-item" }, [
        _c("img", {
          staticClass: "spc-box-plan-icon",
          attrs: { src: require("@/assets/check.svg"), alt: "icon" }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("No ads interuption")])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "spc-box-plan-item" }, [
        _c("img", {
          staticClass: "spc-box-plan-icon",
          attrs: { src: require("@/assets/check.svg"), alt: "icon" }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Play anything")])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "spc-box-plan-item" }, [
        _c("img", {
          staticClass: "spc-box-plan-icon",
          attrs: { src: require("@/assets/check.svg"), alt: "icon" }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Skip anytime you want")])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "spc-box-plan-item" }, [
        _c("img", {
          staticClass: "spc-box-plan-icon",
          attrs: { src: require("@/assets/check.svg"), alt: "icon" }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Listen offline")])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "spc-box-plan-item" }, [
        _c("img", {
          staticClass: "spc-box-plan-icon",
          attrs: { src: require("@/assets/check.svg"), alt: "icon" }
        }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Listen to scripture song’s instrumental accompaniment\n                "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "spc-box-plan-item" }, [
        _c("img", {
          staticClass: "spc-box-plan-icon",
          attrs: { src: require("@/assets/check.svg"), alt: "icon" }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Support adventist artists and missions")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6361863c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6361863c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PremiumPage.vue
// module id = null
// module chunks = 